import resetCss from './reset.css?raw';
import tokensCss from './tokens.css?raw';
import widgetCss from './widget.css?raw';

const STYLE_ID = 'cpw-widget-styles';

export function injectWidgetStyles(root: ShadowRoot | HTMLElement): void {
  if (root.querySelector(`#${STYLE_ID}`)) {
    return;
  }

  const style = document.createElement('style');
  style.id = STYLE_ID;
  style.textContent = [resetCss, tokensCss, widgetCss].join('\n\n');

  root.prepend(style);
}